module.exports = __webpack_public_path__ + "img/hero-agriculture.cae13410.jpg";